import { useEffect, useState } from 'react';
import type { PriorityOption, Page } from '../../common/ui/types';
import { PRIORITY_PICKER_PAGE_SIZE } from '../../constants';
import { toPriorityOption } from '../../services/priorities';

export const usePriorities = (filter: string, pageIndex: number) => {
	const [allPriorities, setAllPriorities] = useState<ReadonlyArray<PriorityOption>>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<unknown>(null);

	useEffect(() => {
		(async () => {
			setLoading(true);
			try {
				const response = await fetch('/rest/api/3/priority');
				const data: unknown = await response.json();
				if (!Array.isArray(data)) {
					throw new Error(`Expected array of priorities, instead got ${typeof data}`);
				}
				setAllPriorities(data.map(toPriorityOption));
			} catch (e: unknown) {
				setError(e);
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	const currentPage = pageIndex + 1;
	const filteredPriorities = filter
		? allPriorities.filter((p) => p.name.toLowerCase().includes(filter.toLowerCase()))
		: allPriorities;
	const page: Page<PriorityOption> = {
		items: filteredPriorities.slice(0, currentPage * PRIORITY_PICKER_PAGE_SIZE),
		currentPage,
		pageSize: PRIORITY_PICKER_PAGE_SIZE,
		totalItems: filteredPriorities.length,
	};

	return { page, loading, error };
};
